module.exports = __WEBPACK_EXTERNAL_MODULE_Pg0u__;


//////////////////
// WEBPACK FOOTER
// external "echarts"
// module id = Pg0u
// module chunks = 78